import api from '@pray/shared/utils/api';

// What the public unsubscribe page shows for a link from the SuperFunnel weekly report email.
// The signed token is the only credential; the page works signed out.
export type WeeklyReportUnsubscribeState = {
  ministry_name: string;
  // The address the link was sent to, masked (p•••@example.org), so a forwarded email reveals little.
  email_hint: string;
  unsubscribed: boolean;
};

type ObjectResponse<T> = { object: string; data: T };

const UNSUBSCRIBE_PATH = '/web/superfunnel-weekly-report/unsubscribe';

export const getWeeklyReportUnsubscribe = async (token: string): Promise<WeeklyReportUnsubscribeState> => {
  const response = await api.executeGetRequest<ObjectResponse<WeeklyReportUnsubscribeState>>(UNSUBSCRIBE_PATH, {
    token,
  });

  return response.data.data;
};

// Safe to repeat: an address already off the list stays off.
export const postWeeklyReportUnsubscribe = async (token: string): Promise<WeeklyReportUnsubscribeState> => {
  const response = await api.executePostRequest<ObjectResponse<WeeklyReportUnsubscribeState>>(UNSUBSCRIBE_PATH, {
    token,
  });

  return response.data.data;
};
